<script lang="ts">
	import type { ChargebeePlanPrice, ChargebeePlanTitle } from "luxedo-rpc/src/routes/chargebee"
	import { LuxLinkSubscriptionManager } from "./LuxLinkSubscriptionController"
	import SubmenuHeading from "../generic/SubmenuHeading.svelte"
	import { ChargebeeManager } from "../../../../../modules/auth/onUserLogin"
	import { AccountNavigator } from "../../AccountStore"
	import { openChargebeeCheckout } from "../ChargebeeRequest"
	import { Responsive } from "responsive"

	let selectedPlan: ChargebeePlanPrice = $state()

	let isPlanAlreadyOwned = $state(false)

	let additonalProjectorAmount: number = $state()
	let addonPricePerUnit: number
	let addonPrice: number = $state()

	LuxLinkSubscriptionManager.subscribe(({ plan, addonQuantity }) => {
		selectedPlan = plan
		additonalProjectorAmount = addonQuantity ?? 0
		const addonPricePlan = ChargebeeManager.getAddonPricing(plan)
		addonPricePerUnit = ChargebeeManager.getPricePerUnit(addonPricePlan, additonalProjectorAmount)
		addonPrice = addonPricePerUnit * additonalProjectorAmount

		if (selectedPlan.id === ChargebeeManager.userPlanSubscriptions?.luxlinkPlan?.price_id)
			isPlanAlreadyOwned = true
		else isPlanAlreadyOwned = false
	})

	function onBack() {
		if (isPlanAlreadyOwned) AccountNavigator.closeSubscription()
		else LuxLinkSubscriptionManager.navigateTo("Subscriber")
	}

	function openCheckout() {
		const family: ChargebeePlanTitle = "Phantasm"

		const checkoutData = {
			customer_id: ChargebeeManager.userPlanSubscriptions.customer.id,
			plan_family: family,
		}

		const subItems = []
		subItems.push({
			item_price_id: selectedPlan.id,
			quantity: 1,
		})

		if (additonalProjectorAmount > 0) {
			const addonPrice = ChargebeeManager.getAddonPricing(selectedPlan)
			subItems.push({
				item_price_id: addonPrice.id,
				quantity: additonalProjectorAmount,
			})
		}

		checkoutData["subscription_items"] = JSON.stringify(subItems)

		let checkoutUrl: string
		if (isPlanAlreadyOwned) checkoutUrl = `/chargebee/generate_checkout_update`
		else checkoutUrl = `/chargebee/generate_checkout_new`

		openChargebeeCheckout(checkoutUrl, checkoutData)
	}
</script>

<SubmenuHeading {onBack}>
	<div class="heading-content">
		<div class="flex-row">
			<h2>Cart</h2>
		</div>
		<span>{Responsive.isMobile ? "Tap" : "Click"} checkout below to finalize your purchase.</span>
	</div>
</SubmenuHeading>

<div class="cart-container">
	<table>
		<thead>
			<tr><th>Item</th><th></th><th>Price</th></tr>
		</thead>
		<tbody>
			<tr>
				<td>{selectedPlan.name}</td>
				<td></td>
				<td>
					{#if isPlanAlreadyOwned}
						Already Owned
					{:else}
						{ChargebeeManager.formatPrice(selectedPlan.price, selectedPlan.currency_code)} / {selectedPlan.period_unit}
					{/if}
				</td>
			</tr>
			<tr>
				<td>Provided LuxLink Projectors: </td>
				<td>2</td>
				<td>$0.00 / {selectedPlan.period_unit}</td>
			</tr>
			<tr>
				<td>Additional LuxLink Projectors: </td>
				<td
					>{additonalProjectorAmount}
					<button
						onclick={() => LuxLinkSubscriptionManager.navigateTo("Additional Projectors")}
						id="edit-additional-projector-button"
						class="small">Edit</button
					></td
				>
				<td
					>{ChargebeeManager.formatPrice(addonPrice, selectedPlan.currency_code)} / {selectedPlan.period_unit}</td
				>
			</tr>
			<tr>
				<td>Total: </td>
				<td></td>
				<td
					>{ChargebeeManager.formatPrice(
						(isPlanAlreadyOwned ? 0 : selectedPlan.price) + addonPrice,
						selectedPlan.currency_code,
					)} / {selectedPlan.period_unit}</td
				>
			</tr>
		</tbody>
	</table>
</div>

<div class="button-container">
	<button onclick={onBack} class="link-button">Cancel</button>
	<button onclick={openCheckout}>Checkout</button>
</div>

<style>
	.cart-container {
		padding: 1rem;
		background-color: var(--color-bg-darker);
		border-radius: var(--br);
	}

	h2 {
		font-size: var(--h1);
		margin: 0;
	}

	.heading-content {
		display: flex;
		flex-direction: column;
	}

	.heading-content > span {
		font-size: var(--h3);
	}

	table {
		width: 100%;
	}

	th {
		font-size: var(--h3);
		color: var(--color-text);
	}

	th:last-of-type,
	td:last-of-type {
		text-align: end;
	}

	td:first-of-type {
		width: 1%;
		white-space: nowrap;
	}

	td:nth-of-type(2) {
		padding-left: 1rem;
	}

	tbody tr:not(:first-of-type, :last-of-type) td {
		padding-left: 1rem;
	}

	tbody tr:last-of-type td {
		padding-top: 1rem;
		color: var(--color-main);
	}

	#edit-additional-projector-button {
		margin-left: 0.5rem;
		padding: 0.05rem 0.5rem;
	}

	.button-container {
		width: fit-content;
		position: absolute;
		bottom: 1rem;
		right: 2rem;
	}
</style>
